import { AuthState } from './types/auth.types';
import { defaultApiState } from '@/store/types/general.types';

export const authState: AuthState = {
  apiState: {
    checkSessionHealth: defaultApiState,
  },
  isLoggedIn: false,
};
